/**
 * Downloads the given file with the given name.
 * @param file The file data
 * @param fileName The file name
 * @param ttl The time to live for the object url (increase for larger files)
 */
function downloadFile(file: object, fileName: string, ttl = 7000): void {
  const link = document.createElement('a');
  link.href = URL.createObjectURL(file);
  link.download = fileName;
  document.body.append(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(link.href), ttl);
}

export default downloadFile;
